module.exports = __webpack_public_path__ + "static/img/4.5725b4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/4.png
// module id = JXRw
// module chunks = 0